// ChoralGovernancePanel.jsx
import React from "react";
import VerificationControls from "./VerificationControls";

function StatusChip({ status }) {
  return (
    <span className={`ce-status-chip ce-status-chip--${status}`} data-testid={`ce-status-chip-${status}`}>
      {status.replace(/_/g, " ")}
    </span>
  );
}

export default function ChoralGovernancePanel({
  work, canVerify, onChanged, apiBase, readOnly = false,
}) {
  const status =
    typeof work.verification_status === "string"
      ? work.verification_status
      : work.verification_status?.value;

  return (
    <section className="ce-panel" data-testid="ce-governance-panel">
      <h3 className="ce-panel__heading">Governance</h3>
      <div className="ce-field">
        <div className="ce-field__label">State</div>
        <div className="ce-field__value">
          <StatusChip status={status} />
        </div>
      </div>
      {work.verified_by && (
        <div className="ce-field">
          <div className="ce-field__label">Verified By</div>
          <div className="ce-field__value">{work.verified_by}</div>
        </div>
      )}
      {work.verified_at && (
        <div className="ce-field">
          <div className="ce-field__label">Verified At</div>
          <div className="ce-field__value" style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: "0.82rem" }}>
            {new Date(work.verified_at).toLocaleString()}
          </div>
        </div>
      )}
      {!readOnly && (
        <div style={{ marginTop: 16 }}>
          <VerificationControls
            work={work}
            canVerify={canVerify}
            onChanged={onChanged}
            apiBase={apiBase}
          />
        </div>
      )}
      {readOnly && (
        <p style={{
          marginTop: 12, fontFamily: '"IBM Plex Mono", monospace',
          fontSize: "0.7rem", color: "var(--li-text-secondary, #5C5450)",
          letterSpacing: "0.08em", textTransform: "uppercase",
        }}>
          Preview mode — governance actions require authentication.
        </p>
      )}
    </section>
  );
}
